// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"5ed7165d","453":"d5916c45"}[chunkId] + ".chunk.js";
};